<div class="row">
  <div class="col-12 m-0">
    <div class="row">
      <div class="col" (click)="collapsed = !collapsed">
        <div class="row">
          <div class="col-auto pr-1 mouse-pointer">
            <p class="{{ color }}" [class.mb-0]="!collapsed">{{ label }}</p>
          </div>
          <div class="col caret mouse-pointer">
            <jhi-bary-icon [icon]="collapsed ? 'caret-down' : 'caret-up'" [faDirective]="FAS" size="sm" [class]="color"></jhi-bary-icon>
          </div>
        </div>
      </div>
      <div class="col-auto">
        <p *ngIf="!suffix" class="{{ color }}" [class.mb-0]="!collapsed">{{ value }}</p>
        <p *ngIf="suffix" class="{{ color }}" [class.mb-0]="!collapsed">{{ value }} {{ suffix }}</p>
      </div>
    </div>
  </div>
  <div class="col-12" *ngIf="!collapsed">
    <div class="row" *ngFor="let item of items; let last = last">
      <div class="col">
        <p class="{{ color }} small" [class.mb-0]="!last" *ngIf="item.nameKey">{{ item.nameKey }}</p>
        <p class="{{ color }} small" [class.mb-0]="!last" *ngIf="!item.nameKey && item.label">{{ item.label }}</p>
      </div>
      <div class="col-auto">
        <p *ngIf="!suffix" class="{{ color }} small" [class.mb-0]="!last">{{ item.value! | currency: currency }}</p>
        <p *ngIf="suffix" class="{{ color }} small" [class.mb-0]="!last">{{ item.value | currency: currency }}</p>
      </div>
    </div>
  </div>
</div>
